export const COMPANY = {
  name: "Global Move Europa",
  claim: "Transporte · Umzüge · Logistik",
  street: "Große Weidestraße 2",
  zip: "28195",
  city: "Bremen",
  country: "Deutschland",
  phoneDisplay: "0176 84683034",
  phoneRaw: "+4917684683034",
  email: "info@global-move-europa.de",
  whatsapp: "4917684683034",
  hours: [
    { d: "Montag – Freitag", t: "08:00 – 20:00 Uhr" },
    { d: "Samstag", t: "09:00 – 19:00 Uhr" },
    { d: "Sonntag", t: "09:00 – 20:00 Uhr" },
  ],
};

export const LOGO =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_010a9a02-a3d8-43cf-8378-738ff0468ecd/artifacts/ou538lo0_ChatGPT%20Image%2010.%20Sept.%202026%2C%2014_20_57.png";

export const waLink = (text) =>
  `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(text)}`;

export const IMG = {
  heroVan:
    "https://static.prod-images.emergentagent.com/jobs/010a9a02-a3d8-43cf-8378-738ff0468ecd/images/33595060bf689c09e95cf28fd7527faf494fd0820a8f2f7dcf5154eadae132d8.jpeg",
  truckAutobahn:
    "https://static.prod-images.emergentagent.com/jobs/010a9a02-a3d8-43cf-8378-738ff0468ecd/images/64ea9f07711dffdcd7fddc9b93165bc447aa1defe32720e823b4664f1e81b4cf.jpeg",
  loadingDark:
    "https://static.prod-images.emergentagent.com/jobs/010a9a02-a3d8-43cf-8378-738ff0468ecd/images/996470a1f35e245e38538bc9a7df9ca7593b21ce66fff98c2dc0ebde214a527d.jpeg",
  palletsDark:
    "https://static.prod-images.emergentagent.com/jobs/010a9a02-a3d8-43cf-8378-738ff0468ecd/images/a2f83df703e945fae74f06a6e0192af27605de6b89387f84529669c51a3f6312.jpeg",
  fernAutobahn:
    "https://static.prod-images.emergentagent.com/jobs/010a9a02-a3d8-43cf-8378-738ff0468ecd/images/505f5be5f0f07ff5a4f6893ae4061ce613d28a54c26abd14b1f281689d3ecbb0.jpeg",
  kleinVan:
    "https://static.prod-images.emergentagent.com/jobs/010a9a02-a3d8-43cf-8378-738ff0468ecd/images/d8077ac00e38e3b0c0ce05c4a7492d9c7c90c24190f2e8e083c2b59890fec0e4.jpeg",
  gewerbeLoading:
    "https://static.prod-images.emergentagent.com/jobs/010a9a02-a3d8-43cf-8378-738ff0468ecd/images/752c42f470119efe4c36207470e2bf8635a790be06f2a0f20838701339b878ef.jpeg",

  highway: "https://images.unsplash.com/photo-1551642019-33a00d23023b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  highway2: "https://images.unsplash.com/photo-1740053045123-2c9ea0f0926e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  pallets: "https://images.unsplash.com/photo-1689942010216-dc412bb1e7a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  forklift: "https://images.unsplash.com/photo-1620388640785-892616248ec8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  boxes: "https://images.unsplash.com/photo-1600725935160-f67ee4f6084a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  boxesOpen: "https://images.unsplash.com/photo-1700165644892-3dd6b67b25bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  boxesPile: "https://images.unsplash.com/photo-1766040923580-16ad32fae8b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  moversStreet: "https://images.unsplash.com/photo-1772724317350-520faccb15e6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  moversCouple: "https://images.unsplash.com/photo-1758523671087-b256bbbca475?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  moversHome: "https://images.unsplash.com/photo-1758523670969-dd1b1254062d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  truckLoading: "https://images.unsplash.com/photo-1614359835514-92f8ba196357?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  truckYellow: "https://images.unsplash.com/photo-1600518464441-9154a4dea21b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  office: "https://images.unsplash.com/photo-1700809887584-0798672b1d48?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  assembly: "https://images.unsplash.com/photo-1623043453741-11aef9cb59b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  assembly2: "https://images.unsplash.com/photo-1667936503298-0d331fadc4db?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  racks: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  warehouse: "https://images.unsplash.com/photo-1672552226380-486fe900b322?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const SERVICES = [
  {
    slug: "umzuege",
    title: "Umzüge",
    tag: "Privat & Gewerbe",
    img: IMG.moversCouple,
    text: "Wohnungs-, Haus- und Büroumzüge – geplant, gepackt, transportiert und am Ziel wieder aufgebaut.",
    long: "Ob Ein-Zimmer-Wohnung, Einfamilienhaus oder komplettes Büro: Wir klären vorab Umfang, Etagen, Zugänge und Parksituation und stellen Fahrzeug und Team passend zusammen. Empfindliche Möbel werden abgedeckt und gesichert, Kartons beschriftet und raumweise abgestellt.",
    bullets: ["Privat- und Firmenumzüge", "Demontage und Montage möglich", "Packmaterial auf Wunsch", "Feste Zeitfenster"],
  },
  {
    slug: "moebeltransporte",
    title: "Möbeltransporte",
    tag: "Sorgfältig",
    img: IMG.loadingDark,
    text: "Einzelne Möbelstücke oder komplette Einrichtungen – gepolstert, gegurtet und schadenfrei geliefert.",
    long: "Sofa, Schrank, Esstisch oder eine komplette Einrichtung: Möbel werden mit Decken abgedeckt, an Kanten geschützt und im Fahrzeug verzurrt. So kommt auch empfindliches Massivholz ohne Druckstellen an.",
    bullets: ["Decken, Gurte, Kantenschutz", "Auch enge Treppenhäuser", "Abholung beim Händler möglich", "Terminierte Lieferung"],
  },
  {
    slug: "kleintransporte",
    title: "Kleintransporte",
    tag: "Kurzfristig",
    img: IMG.kleinVan,
    text: "Kleine Ladungen, Küchengeräte oder Kaufabholungen – flexibel und oft auch kurzfristig möglich.",
    long: "Für kleine Mengen braucht es keinen großen LKW. Wir fahren mit dem Transporter, holen ab und liefern zuverlässig – häufig auch spontan innerhalb weniger Tage.",
    bullets: ["Transporter statt LKW", "Kurzfristige Termine", "Bremen und Umgebung", "Einzelne Stücke möglich"],
  },
  {
    slug: "ferntransporte",
    title: "Ferntransporte",
    tag: "Deutschlandweit",
    img: IMG.fernAutobahn,
    text: "Transporte über größere Distanzen innerhalb Deutschlands – zuverlässig terminiert und abgestimmt.",
    long: "Von Bremen in jedes Bundesland: Wir planen Route und Zeitfenster so, dass Abholung und Lieferung zu Ihrem Ablauf passen. Auf langen Strecken sind Beiladungen eine günstige Alternative.",
    bullets: ["Alle Bundesländer", "Abgestimmte Zeitfenster", "Beiladung möglich", "Direktfahrten auf Anfrage"],
  },
  {
    slug: "europaweite-transporte",
    title: "Europaweite Transporte",
    tag: "Grenzüberschreitend",
    img: IMG.truckAutobahn,
    text: "Grenzüberschreitende Transporte in ganz Europa mit klarer Routen- und Terminplanung.",
    long: "Niederlande, Belgien, Frankreich, Österreich, Schweiz, Polen, Italien und weitere Ziele: Grenzüberschreitende Transporte erfordern saubere Planung. Wir klären Route, Zeitfenster und Ladungssicherung vorab mit Ihnen ab.",
    bullets: ["EU-weite Ziele", "Routen- und Zeitplanung", "Ladungssicherung nach Vorschrift", "Ein Ansprechpartner"],
  },
  {
    slug: "gewerbliche-transporte",
    title: "Gewerbliche Transporte",
    tag: "B2B",
    img: IMG.gewerbeLoading,
    text: "Waren, Maschinen und Betriebsausstattung für Unternehmen, Handwerk und Handel.",
    long: "Für Gewerbekunden transportieren wir Waren, Ausstattung und Maschinen zwischen Standorten, Lager und Kunden. Termine werden so gelegt, dass Ihr Betrieb weiterläuft.",
    bullets: ["Standort- und Lagerverkehre", "Termine außerhalb der Stoßzeiten", "Regelmäßige Fahrten möglich", "Rechnung auf Firma"],
  },
  {
    slug: "palettentransporte",
    title: "Palettentransporte",
    tag: "Stückgut",
    img: IMG.palletsDark,
    text: "Europaletten und Stückgut sicher verladen, gesichert und dokumentiert bewegt.",
    long: "Paletten werden gewickelt, gesichert und so verladen, dass nichts verrutscht. Auf Wunsch übernehmen wir Abholung direkt an der Laderampe.",
    bullets: ["Europaletten & Einwegpaletten", "Abholung an der Rampe", "Wickeln und Sichern", "Einzelne oder mehrere Paletten"],
  },
  {
    slug: "einzeltransporte",
    title: "Einzeltransporte",
    tag: "Direktfahrt",
    img: IMG.heroVan,
    text: "Ein Stück, ein Fahrzeug, eine Fahrt – direkt von A nach B ohne Umladen.",
    long: "Wenn es schnell und ohne Umladen gehen soll: Wir fahren Ihr Einzelstück direkt zum Ziel. Ideal für wertvolle, empfindliche oder eilige Ladung.",
    bullets: ["Kein Umladen", "Direkte Route", "Auch empfindliche Stücke", "Termin nach Absprache"],
  },
  {
    slug: "beiladungen",
    title: "Beiladungen",
    tag: "Kosteneffizient",
    img: IMG.pallets,
    text: "Sie zahlen nur den Laderaum, den Sie brauchen – ideal für kleinere Mengen auf langen Strecken.",
    long: "Bei einer Beiladung teilen mehrere Ladungen ein Fahrzeug. Das senkt die Kosten deutlich, erfordert aber ein flexibleres Zeitfenster. Wir sagen Ihnen ehrlich, ob das für Ihren Fall sinnvoll ist.",
    bullets: ["Deutlich günstiger", "Flexibles Zeitfenster", "Lange Strecken", "Kleine bis mittlere Mengen"],
  },
  {
    slug: "sperrguttransporte",
    title: "Sperrguttransporte",
    tag: "Übergroß",
    img: IMG.forklift,
    text: "Sperrige und schwere Güter, die besondere Technik und erfahrene Hände brauchen.",
    long: "Große Schränke, Maschinen, Marmorplatten oder sperrige Einzelteile: Hier zählt Erfahrung. Wir planen Zugang, Hilfsmittel und Teamgröße vorab und bewegen die Ladung kontrolliert.",
    bullets: ["Schwere Einzelstücke", "Planung von Zugängen", "Passende Hilfsmittel", "Erfahrenes Team"],
  },
  {
    slug: "umzugshelfer",
    title: "Umzugshelfer",
    tag: "Stundenweise",
    img: IMG.moversStreet,
    text: "Erfahrene Helfer für Tragen, Laden und Absichern – stundenweise oder für den ganzen Tag.",
    long: "Sie haben ein Fahrzeug, brauchen aber Hände? Unsere Helfer packen an, tragen, laden und sichern. Buchbar stundenweise oder für den kompletten Umzugstag.",
    bullets: ["Stundenweise buchbar", "Tragen und Verladen", "Ladungssicherung", "Auch am Wochenende"],
  },
  {
    slug: "moebelmontage",
    title: "Möbelmontage",
    tag: "Handwerk",
    img: IMG.assembly,
    text: "Demontage am Startort, Transport und fachgerechter Wiederaufbau am Ziel – aus einer Hand.",
    long: "Betten, Schränke, Küchen und Büromöbel bauen wir ab, transportieren sie geschützt und stellen sie am Ziel wieder auf. Schrauben und Kleinteile werden beschriftet mitgeführt.",
    bullets: ["Demontage & Montage", "Beschriftete Kleinteile", "Aufbau nach Wunsch", "Auch Büromöbel"],
  },
];

export const WHY = [
  { t: "Persönliche Betreuung", d: "Ein Ansprechpartner von der ersten Anfrage bis zur Ankunft." },
  { t: "Flexible Transportlösungen", d: "Fahrzeug, Teamgröße und Termin richten sich nach Ihrer Ladung." },
  { t: "Deutschlandweite Transporte", d: "Von Bremen aus in jede Stadt und jede Region Deutschlands." },
  { t: "Europaweite Transporte", d: "Grenzüberschreitend mit abgestimmter Route und Zeitfenster." },
  { t: "Sorgfältiger Umgang mit Transportgut", d: "Decken, Gurte und Kantenschutz gehören zur Standardausrüstung." },
  { t: "Individuelle Planung", d: "Jeder Transport wird auf Basis Ihrer konkreten Angaben kalkuliert." },
  { t: "Direkter Ansprechpartner", d: "Kein Callcenter, keine Warteschleife – Sie sprechen direkt mit uns." },
  { t: "Anfrage per WhatsApp", d: "Fotos, Maße und Adressen in Sekunden geschickt – ohne Formularstress." },
];

export const PROCESS = [
  { t: "Anfrage senden", d: "Konfigurator, WhatsApp oder Telefon – Sie entscheiden, wie Sie starten." },
  { t: "Transportdetails übermitteln", d: "Ladung, Adressen, Etagen und Wunschtermin – gern auch mit Fotos." },
  { t: "Individuelles Angebot erhalten", d: "Sie bekommen ein Angebot mit klar benannten Leistungen." },
  { t: "Termin vereinbaren", d: "Wir reservieren Fahrzeug und Team für Ihr Zeitfenster." },
  { t: "Transport durchführen", d: "Fachgerecht laden, sichern und auf der geplanten Route bewegen." },
  { t: "Sicher am Ziel ankommen", d: "Abladen, aufstellen, montieren – kontrolliert übergeben." },
];

export const NAV = [
  { label: "Leistungen", href: "/#leistungen" },
  { label: "Umzüge", href: "/#umzuege" },
  { label: "Transporte", href: "/#logistik" },
  { label: "Über uns", href: "/#ueber-uns" },
  { label: "Kontakt", href: "/#kontakt" },
];

export const CARGO = [
  { v: "Möbel", d: "Sofa, Schrank, Bett, Tisch" },
  { v: "Umzug", d: "Wohnung, Haus oder Büro" },
  { v: "Einzelstück", d: "Ein Teil, direkte Fahrt" },
  { v: "Kartons", d: "Verpackte Kleinteile" },
  { v: "Paletten", d: "Stückgut und Europaletten" },
  { v: "Gewerbliche Waren", d: "Handel, Handwerk, Betrieb" },
  { v: "Sperrgut", d: "Übergroß oder schwer" },
  { v: "Sonstiges", d: "Beschreiben Sie es uns" },
];

export const ROUTE_STATIONS = [
  { k: "Bremen", d: "Unser Standort: Große Weidestraße 2, 28195 Bremen. Kurze Wege, schnelle Termine in der Region." },
  { k: "Deutschland", d: "Hamburg, Berlin, Hannover, Köln, Frankfurt, München – Ferntransporte in alle Bundesländer." },
  { k: "Europa", d: "Amsterdam, Brüssel, Paris, Zürich, Wien, Warschau – grenzüberschreitend mit klarer Planung." },
];
